// extracted by mini-css-extract-plugin
module.exports = {"statusColumn":"ProductList_statusColumn_Qtau8","actionColumn":"ProductList_actionColumn_3RGcJ"};